/* eslint-disable unicorn/numeric-separators-style */
import React, { useEffect, useState } from 'react';
import { fetchProduct } from '../../../fetchers/products';
import { IProduct } from '../../../models/product';
import ProductPage from '../../../components/ProductDetail/ProductPage';
import MyHead from '../../../components/MyHead';
import Footer from '../../../components/Footer';
import Menu from '../../../components/Menu/Menu';
import {
  getLangCountry,
  getRealLangCountry,
  SUPPORTED_LANG
} from '../../../helpers/languages';
import { useRouter } from 'next/router';
import { GetStaticPropsContext, NextPage } from 'next';
import { fetchAlternateUrls } from '../../../fetchers/commons';
import { AlternateLangs } from '../../../models/app';
import { useTranslation } from 'react-i18next';
import { DYNAMIC_PAGE_STATIC_PATHS } from '../../../helpers/staticPaths';
import { getToken } from '../../../helpers/auth';
import { SUPPORTED_COUNTRY } from '../../../helpers/countries';

interface ISlugPageProps {
  alternates: AlternateLangs[];
  product: IProduct;
  pageContent: {
    page_content: string;
    page_css: string;
    blog_css_url: string;
    body_class: string;
    page_id: string;
    language: string;
  };
  slug: string;
}

const SlugPage: NextPage<ISlugPageProps> = ({ alternates = [], product }) => {
  const { pathname, query } = useRouter();
  const [loading, setLoading] = useState(false);
  const { lang, country } = getLangCountry(query);
  const { t } = useTranslation();
  const [productCustomer, setProductCustomer] = useState<IProduct | null>();
  const token = getToken();

  // useEffect(() => gTag.event({ action: 'ViewContent', label: pathname }), []);

  useEffect(() => {
    if (product) {
      setProductCustomer(null);
      fetchProductWithToken();
    }
  }, [product]);

  const fetchProductWithToken = async () => {
    setLoading(true);
    const p = await fetchProduct({ lang, country, slug: product.slug, token });
    if (p) {
      setProductCustomer(p);
    }
    setLoading(false);
  };

  return (
    <>
      <MyHead
        title={(productCustomer || product).productName}
        description={(productCustomer || product).description}
        alternates={alternates}
      />
      {/* <BannerShipping /> */}
      <div>
        <Menu />
        <ProductPage
          product={productCustomer || product}
          loading={loading}
          shippmentAndReturnInfoText={t('SHIPMENT_AND_RETURN_INFO')}
        />
        <Footer />
      </div>
    </>
  );
};

export async function getStaticProps(context: GetStaticPropsContext) {
  const { params } = context;
  const { lang, country } = getLangCountry(params);

  const real = getRealLangCountry(params);
  if (
    !SUPPORTED_LANG.includes(real.lang) ||
    !SUPPORTED_COUNTRY.includes(real.country)
  ) {
    return { notFound: true };
  }

  const slug: string =
    params && params.slug
      ? typeof params?.slug === 'string'
        ? params.slug
        : params.slug[0]
      : '';

  const apiParams = { lang, country };
  const [product, alternates] = await Promise.all([
    fetchProduct({ ...apiParams, slug }),
    fetchAlternateUrls({
      url: slug,
      lang,
      country
    })
  ]);

  if (!product) {
    return {
      notFound: true,
      revalidate: 60
    };
  }

  return {
    props: {
      alternates,
      product
    },
    revalidate: 86400
  };
}

export async function getStaticPaths() {
  return {
    paths: DYNAMIC_PAGE_STATIC_PATHS(),
    fallback: 'blocking'
  };
}

export default SlugPage;
